export const environment = {
  production: false,
  baseUrl: 'https://kellton-commercedev.kellton.net/api', // eg:'http://localhost:9000/backend/api/'
  imageUrl: 'https://kellton-commercedev.kellton.net/api/media/image-resize/', // eg:'http://localhost:9000/backend/api/media/image-resize'
  productUrl: '<Your store base url>', // eg:'http://yourip.com/'
  pluginUrl: '<Your API url>' ,// eg:'http://yourip.com/'
  labelUrl : 'https://kellton-commercedev.kellton.net/api'

};